import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import trademarkLogo from '../assets/Trademark.svg';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    about: [
      { name: 'Company Overview', href: '/about/company-overview', isRoute: true },
      { name: 'Directors', href: '/about/directors', isRoute: true },
      { name: 'Manufacturing', href: '/about/manufacturing', isRoute: true },
      { name: 'Quality', href: '/about/quality', isRoute: true },
      { name: 'Factory Gallery', href: '/about/factory-gallery', isRoute: true }
    ],
    products: [
      { name: 'Core Products', href: '/products', isRoute: true },
      { name: 'BOPP Laminated Bags', href: '/products/bopp-laminated-bags', isRoute: true },
      { name: 'PP Woven Bags', href: '/products/pp-woven-bags', isRoute: true },
      { name: 'PP Rolls', href: '/products/pp-rolls', isRoute: true },
      { name: 'Laminated Woven Bags', href: '/products/laminated-woven-bags', isRoute: true },
      { name: 'FIBC', href: '/products/fibc', isRoute: true }
    ],
    markets: [
      { name: 'FMCG', href: '/markets/fmcg', isRoute: true },
      { name: 'Mining & Minerals', href: '/markets/mining-minerals', isRoute: true },
      { name: 'Seed & Crops', href: '/markets/seed-crops', isRoute: true },
      { name: 'Animal Nutrition', href: '/markets/animal-nutrition', isRoute: true },
      { name: 'Construction', href: '/markets/construction', isRoute: true }
    ],
    support: [
      { name: 'Home', href: '/', isRoute: true },
      { name: 'I Am Recyclable', href: '/i-am-recyclable', isRoute: true },
      { name: 'Contact Us', href: '/#contact', isRoute: false }
    ]
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section company-info">
              <div className="footer-logo">
                <img src={trademarkLogo} alt="Maharaja Polyfab" className="footer-logo-img" />
                <p>Complete Bulk Packaging Solutions</p>
              </div>
              <p className="company-description">
                Leading manufacturer and exporter of FIBC, Big Bags and Food Grade FIBC 
                (BRC & ISO 22000 Certified), providing comprehensive bulk packaging solutions 
                under one roof.
              </p>
              <div className="social-links">
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <i className="fab fa-facebook"></i>
                </a>
                <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <i className="fab fa-linkedin"></i>
                </a>
                <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>

            <div className="footer-section">
              <h4>About Us</h4>
              <ul>
                {footerLinks.about.map((link, index) => (
                  <li key={index}>
                    {link.isRoute ? (
                      <Link to={link.href}>{link.name}</Link>
                    ) : (
                      <a href={link.href}>{link.name}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-section">
              <h4>Products</h4>
              <ul>
                {footerLinks.products.map((link, index) => (
                  <li key={index}>
                    {link.isRoute ? (
                      <Link to={link.href}>{link.name}</Link>
                    ) : (
                      <a href={link.href}>{link.name}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-section">
              <h4>Markets Served</h4>
              <ul>
                {footerLinks.markets.map((link, index) => (
                  <li key={index}>
                    {link.isRoute ? (
                      <Link to={link.href}>{link.name}</Link>
                    ) : (
                      <a href={link.href}>{link.name}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-section">
              <h4>Support</h4>
              <ul>
                {footerLinks.support.map((link, index) => (
                  <li key={index}>
                    {link.isRoute ? (
                      <Link to={link.href}>{link.name}</Link>
                    ) : (
                      <a href={link.href}>{link.name}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="footer-info">
              <div className="contact-info">
                <span>
                  <i className="fas fa-phone"></i>
                  +91-9348335684 / +91-7008306474
                </span>
                <span>
                  <i className="fas fa-envelope"></i>
                  maharajapolyfabpvtltd@gmail.com
                </span>
              </div>
            </div>
            
          </div>

          <div className="footer-copyright">
            <p>
              © {currentYear} Maharaja Polyfab Limited. All rights reserved. 
              Made with ❤️ by Kapil Sharma.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
